"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stytchEmailResendMessageSaga = exports.stytchEmailResendMessageResponse = exports.stytchEmailResendMessage = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const typed_redux_saga_1 = require("typed-redux-saga");
const api_1 = require("../../api");
const stytchLoadingSlot_1 = require("./stytchLoadingSlot");
const stytchWarning_1 = require("./stytchWarning");
exports.stytchEmailResendMessage = (0, toolkit_1.createAction)('AUTHENTICATION/STYTCH/EMAIL/RESEND_MESSAGE');
exports.stytchEmailResendMessageResponse = (0, toolkit_1.createAction)('AUTHENTICATION/STYTCH/EMAIL/RESEND_MESSAGE/RESPONSE');
function* stytchEmailResendMessageSaga({ payload: { userId, email, termsAccepted, enableNewsletter, basePath, redirect, }, }) {
    yield* (0, typed_redux_saga_1.put)((0, stytchWarning_1.stytchClearWarnings)());
    yield* (0, typed_redux_saga_1.put)((0, stytchLoadingSlot_1.stytchSetLoadingSlot)({
        slot: stytchLoadingSlot_1.StytchLoadingSlot.EMAIL_RESEND_MESSAGE,
        loading: true,
    }));
    try {
        const userServiceAddress = yield* (0, typed_redux_saga_1.call)(typed_redux_saga_1.getContext, 'userServiceAddress');
        const response = yield* (0, typed_redux_saga_1.call)(api_1.stytchFetchEmailResendMessage, {
            userId,
            email,
            termsAccepted,
            enableNewsletter,
            userServiceAddress: userServiceAddress,
            basePath,
            redirect,
        });
        if (response.ok) {
            yield* (0, typed_redux_saga_1.put)((0, exports.stytchEmailResendMessageResponse)({
                userId,
                email,
                termsAccepted,
                enableNewsletter,
            }));
        }
        else if (response.status === 400) {
            const responseJson = yield* (0, typed_redux_saga_1.call)([response, 'json']);
            yield* (0, typed_redux_saga_1.put)((0, stytchWarning_1.stytchSetWarning)({
                slot: stytchWarning_1.StytchWarningSlot.EMAIL_RESEND_MESSAGE,
                isValid: false,
                message: responseJson.detail,
            }));
        }
        else if (response.status === 429) {
            yield* (0, typed_redux_saga_1.put)((0, stytchWarning_1.stytchSetWarning)({
                slot: stytchWarning_1.StytchWarningSlot.EMAIL_RESEND_MESSAGE,
                isValid: false,
                message: stytchWarning_1.StytchWarningMessage.EMAIL_RESEND_MESSAGE_TOO_SOON,
            }));
        }
        else {
            yield* (0, typed_redux_saga_1.put)((0, stytchWarning_1.stytchSetWarning)({
                slot: stytchWarning_1.StytchWarningSlot.EMAIL_RESEND_MESSAGE,
                isValid: false,
                message: stytchWarning_1.StytchWarningMessage.EMAIL_RESEND_MESSAGE,
            }));
        }
    }
    catch (e) {
        const { message: errorMessage } = e;
        if (errorMessage) {
            yield* (0, typed_redux_saga_1.put)((0, stytchWarning_1.stytchSetWarning)({
                slot: stytchWarning_1.StytchWarningSlot.EMAIL_RESEND_MESSAGE,
                isValid: false,
                message: errorMessage,
            }));
        }
        else {
            yield* (0, typed_redux_saga_1.put)((0, stytchWarning_1.stytchSetWarning)({
                slot: stytchWarning_1.StytchWarningSlot.EMAIL_RESEND_MESSAGE,
                isValid: false,
                message: stytchWarning_1.StytchWarningMessage.EMAIL_RESEND_MESSAGE,
            }));
        }
    }
    finally {
        yield* (0, typed_redux_saga_1.put)((0, stytchLoadingSlot_1.stytchSetLoadingSlot)({
            slot: stytchLoadingSlot_1.StytchLoadingSlot.EMAIL_RESEND_MESSAGE,
            loading: false,
        }));
    }
}
exports.stytchEmailResendMessageSaga = stytchEmailResendMessageSaga;
